import React from 'react';
import Layout from '../components/Layout';
import { Users } from 'lucide-react';
import ActiveSessionsPanel from '../components/ActiveSessionsPanel';

function ActiveSessions() {
  return (
    <Layout>
      <div className="p-6 space-y-4">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <Users className="w-6 h-6 text-blue-600" />
          Active Sessions
        </h1>
        <ActiveSessionsPanel />
      </div>
    </Layout>
  );
}

export default ActiveSessions;
